import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.css";
import App from "./App.tsx";
import { LoadScript } from '@react-google-maps/api';
import './config/amplify-config';

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <LoadScript
        googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
        libraries={['places']}
      >
        <App />
      </LoadScript>
    </Provider>
  </StrictMode>,
);
